import React, { useState, useEffect, useCallback } from "react";

// ** MUI Imports
import Grid from "@mui/material/Grid";

// **  Components Imports
import ClientDetails from "./ClientDetails";
import ClientTabs from "./ClientTabs";

// ** Router
import { useParams } from "react-router-dom";

// Service
import ClientService from "src/service/Client";

const Client = () => {
  // Data
  let [data, setData] = useState(null);

  // ** Hooks
  const params = useParams();

  // API
  useEffect(() => {
    ClientService.getOne(params.id).then((r) => setData(r.data));
  }, []);

  // Handlers
  const updateData = useCallback(updated => {
    setData(Object.assign({}, data, updated))
  })

  if (!data) return null;

  return (
    <Grid container spacing={6}>
      <Grid item xs={12} md={5} lg={4}>
        <ClientDetails data={data} updateData={updateData} />
      </Grid>
      <Grid item xs={12} md={7} lg={8}>
        <ClientTabs client={data} />
      </Grid>
    </Grid>
  );
};

export default Client;
